import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';
import { StatisticsUserOutput } from 'user/model/statistics-user.output';

import { statisticsUser } from '../model/statistics-user.fragments';

@Injectable({ providedIn: 'root' })
export class FetchStatisticsUserApiQuery extends ApiQuery<
	StatisticsUserOutput,
	void
> {
	client = 'statistics';
	document = gql`
		query FetchStatisticsUser {
			fetchUser {
				...User
			}
		}
		${statisticsUser}
	`;
	method = 'fetchUser';
}
